import { Link } from "gatsby"
import { default as React } from "react"
import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
} from "react-instantsearch-dom"

const HitCount = connectStateResults(({ searchResults, en }) => {
  const hitCount = searchResults && searchResults.nbHits

  return hitCount > 0 && hitCount < 200 ? (
    <div className="HitCount">
      {hitCount} {hitCount !== 1 && en === false ? `resultaten` : `resultaat`} {hitCount !== 1 && en === true ? `result` : `results`}
    </div>
  ) : <div className="HitCount">{en === true ? 'No results' : 'Geen resultaten'}</div>
})

const PageHit = ({ hit }) => (
  <div>
    <Link to={`/${hit.full_slug}`}>
      <Highlight attribute="name" hit={hit} tagName="mark" />
    </Link>
  </div>
)

const HitsInIndex = ({ index }) => (
  <Index indexName={index.name}>
    <div className="Flex">
      <img src="/wa-logo.svg" height="36" width="90" alt="WA.nl logo" />
      <HitCount />
    </div>
    <Hits className="Hits" hitComponent={PageHit} />
  </Index>
)

const SearchResult = ({ indices, className }) => (
  <div className={className}>
    {indices.map(index => (
      <HitsInIndex index={index} key={index.name} />
    ))}
  </div>
)

export default SearchResult